import axiosInstance from './api'
import { shouldUseApplicationFlowFixtures, fixtureFetchEssaySummary } from 'fixtures/applicationFlowFixtures'

export const fetchEssaySummary = async () => {
	if (shouldUseApplicationFlowFixtures()) return fixtureFetchEssaySummary()

	const response = await axiosInstance.get('/counseling/essay-summary')
	return response.data || {}
}
